var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"canvas-wrap"},[_c('canvas',{ref:"canvasElement",staticClass:"canvas",attrs:{"data-fill":_setup.props.fill,"width":_setup.props.width ?? 0,"height":_setup.props.height ?? 0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }